import React, { useRef, useState, useEffect } from 'react';
import { useParams } from "react-router";
import { Skeleton, Empty, Button, message, Modal, List } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { IMAGES, UPLOADS, FILES } from '../../../../params';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import { TbReload } from "react-icons/tb";
SwiperCore.use([Autoplay, Navigation, Pagination]);

export const Item = props => {
    
    const dispatch = useDispatch();
    const app_global = useSelector(state => state.app_global);
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [activeModal, setActiveModal] = useState("");

    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [paginationSize, setPaginationSize] = useState(6);

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                <>
                    <Modal mask centered className="modal_portal" key="m1" width={1600} title="ТОП полезных фруктов" open={activeModal === 'fruits'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>ТОП полезных фруктов</h2>
                        </div>
                        <div className='text_content'>

                        </div>
                        <div className='list_ul'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 6,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: 'Гранат',
                                            text: '— это один из самых полезных фруктов благодаря своим антиоксидантным свойствам. Гранат содержит витамин С, калий и полифенолы, которые могут помочь защитить клетки от свободных радикалов и уменьшить риск сердечно-сосудистых заболеваний'
                                        },{
                                            title: 'Авокадо',
                                            text: '- это фрукт, содержащий мононенасыщенные жиры, калий, витамин К и фолат. Эти вещества могут помочь снизить уровень холестерина в крови, поддержать здоровье костей и уменьшить риск развития диабета.'
                                        },{
                                            title: 'Яблоко',
                                            text: '— яблоки содержат витамин C, клетчатку и антиоксиданты, которые могут помочь улучшить здоровье кожи, поддерживать здоровье сердца и снизить риск развития рака'
                                        },{
                                            title: 'Голубика',
                                            text: '— это фрукт, содержащий антоцианы, которые могут помочь защитить клетки от повреждений, вызванных свободными радикалами, и снизить риск развития некоторых видов рака и сердечно -сосудистых заболеваний'
                                        },{
                                            title: 'Ананас',
                                            text: '— это фрукт, содержащий бромелайн, который может помочь улучшить пищеварение и снизить воспаление в организме'
                                        },{
                                            title: 'Черника',
                                            text: '— это фрукт, содержащий антоцианы и витамин С, которые могут помочь улучшить зрение, поддерживать здоровье сердца и снизить риск развития диабета'
                                        },{
                                            title: 'Киви',
                                            text: '— это фрукт, содержащий витамин C, калий и антиоксиданты, которые могут помочь укрепить иммунную систему, поддерживать здоровье кожи и снизить риск развития астмы'
                                        },{
                                            title: 'Грейпфрут',
                                            text: '— это фрукт, содержащий витамин C и антиоксиданты, которые могут помочь снизить уровень холестерина в крови и улучшить здоровье сердца'
                                        },{
                                            title: 'Манго',
                                            text: '— это фрукт, содержащий витамин C, витамин A и антиоксиданты, которые могут помочь улучшить здоровье кожи, поддерживать здоровье глаз и снизить риск развития рака'
                                        },{
                                            title: 'Клубника',
                                            text: '— это фрукт, содержащий витамин C, антоцианы и клетчатку, которые могут помочь снизить уровень холестерина в крови, улучшить здоровье кожи и снизить риск развития рака'
                                        },{
                                            title: 'Груша',
                                            text: '— это фрукт, содержащий витамин С, клетчатку и бор, который может помочь поддерживать здоровье костей и улучшить пищеварение'
                                        },{
                                            title: 'Арбуз',
                                            text: '— это фрукт, содержащий много воды и электролитов, которые могут помочь увлажнить кожу, снизить уровень стресса в организме и улучшить работу сердечно-сосудистой системы'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page - 1) * paginationSize + index + 1}`} >
                                        <none />
                                        <p className='title'>{item.title}</p>
                                        <p className='text'>{item.text}</p>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/fruits.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <Modal mask centered className="modal_portal" key="m2" width={1600} title="ТОП полезных овощей" open={activeModal === 'vegetables'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>ТОП полезных овощей</h2>
                        </div>
                        <div className='text_content'>

                        </div>
                        <div className='list_ul'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 6,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: 'Брокколи',
                                            text: '— содержит большое количество витамина С, кальция, железа и антиоксидантов, которые могут помочь защитить клетки от повреждений, связанных с возрастом, улучшить здоровье костей и снизить риск развития рака'
                                        },{
                                            title: 'Шпинат',
                                            text: '— содержит много витаминов и минералов, таких как витамин К, железо и калий, которые могут помочь снизить уровень холестерина в крови, укрепить иммунную систему и улучшить здоровье костей'
                                        },{
                                            title: 'Капуста',
                                            text: '— содержит витамины А, С и К, фолат и антиоксиданты, которые могут помочь улучшить здоровье кожи, поддержать здоровье костей и снизить риск развития рака'
                                        },{
                                            title: 'Морковь',
                                            text: '— содержит каротиноиды, которые могут помочь улучшить зрение, а также витамин А, который может помочь укрепить иммунную систему'
                                        },{
                                            title: 'Томаты',
                                            text: '— содержат ликопин, который может помочь снизить риск развития рака и улучшить здоровье сердца'
                                        },{
                                            title: 'Лук',
                                            text: '— содержит флавоноиды и антиоксиданты, которые могут помочь улучшить здоровье сердца, а также сульфиды, которые могут помочь снизить уровень холестерина в крови'
                                        },{
                                            title: 'Цветная капуста',
                                            text: '— содержит витамины C и К, антиоксиданты и другие питательные вещества, которые могут помочь улучшить здоровье костей, зрения и иммунной системы'
                                        },{
                                            title: 'Батат',
                                            text: '— содержит витамины A, C и E, калий, бета-каротин и другие питательные вещества, которые могут помочь улучшить здоровье кожи, зрения и костей'
                                        },{
                                            title: 'Перец',
                                            text: '— содержит витамины C и A, калий, фолат и другие питательные вещества, которые могут помочь снизить уровень холестерина в крови, укрепить иммунную систему и улучшить здоровье костей'
                                        },{
                                            title: 'Спаржа',
                                            text: '— содержит витамины А, С, Е, К и группу В, а также магний, железо и калий. Она может помочь улучшить пищеварение, снизить уровень холестерина в крови и укрепить иммунную систему. Также спаржа содержит инулин, который является пребиотиком и способствует росту полезных бактерий в кишечнике, что может помочь улучшить здоровье кишечника и снизить риск развития некоторых заболеваний'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} >
                                        <none />
                                        <p className='title'>{item.title}</p>
                                        <p className='text'>{item.text}</p>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/vegetables.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <section className='container_full --hls_item_2'>
                        <section className='top'>
                            <section className='container shadow default_padding'>
                                <h1>Употребляйте свежие продукты</h1>
                            </section>
                        </section>
                        <section className='body'>
                            <section className='container shadow default_padding'>
                                <section className='left'>
                                    <p className='title'>Рекомендуем ознакомиться</p>
                                    <p className='excerpt'>Прочитав статьи вы сможете качественно улучшить текущее состояние вашего здоровья.</p>
                                    <div className='slider_pc'>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый образ жизни</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Правильное питание</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Физическая активность</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_03.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый сон</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='slider_mob'>
                                        <Swiper
                                            loop
                                            spaceBetween={12}
                                            slidesPerView={1.5}
                                            pagination={{
                                                type: "progressbar",
                                            }}
                                            navigation={{
                                                prevEl: navigationPrevRef.current,
                                                nextEl: navigationNextRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                swiper.params.navigation.nextEl = navigationNextRef.current;
                                            }}
                                            breakpoints={{
                                                992: {
                                                    slidesPerView: 2.75,
                                                },
                                                991: {
                                                    slidesPerView: 2,
                                                },
                                                700: {
                                                    slidesPerView: 1.5,
                                                },
                                            }}
                                        >
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый образ жизни</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Правильное питание</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Физическая активность</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_03.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый сон</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        </Swiper>
                                    </div>
                                </section>
                                <section className='right'>
                                    <div className='content'>
                                        <div className='header'>
                                            <div className='posts_image_big'>
                                                <img src={`${IMAGES}/banners/hls_image_01_02_01.jpeg`} />
                                            </div>
                                        </div>

                                        <div className='body'>
                                            <div className='text_content'>
                                                <p>Свежие овощи — это богатый источник витаминов, минералов, антиоксидантов и других питательных веществ, которые необходимы для поддержания здоровья и нормального функционирования организма. </p>
                                                <p>Потребление свежих овощей помогает укреплять иммунную систему, снижать уровень вредного холестерина в крови, улучшать работу пищеварительной системы, поддерживать нормальный уровень сахара в крови и снижать риск развития различных заболеваний, таких как сердечно-сосудистые заболевания, диабет, ожирение и рак.</p>
                                                <p>Свежие овощи также содержат большое количество воды и диетических волокон, которые способствуют насыщению и контролю аппетита, что может помочь при снижении веса и поддержании формы. </p>
                                                <p>Кроме того, свежие овощи имеют более яркий и насыщенный вкус, чем консервированные или замороженные, что делает их более привлекательными для употребления в пищу. Поэтому, важно включать свежие овощи в свой рацион и предпочитать их консервированным или замороженным аналогам.</p>
                                            </div>
                                            <section className='container shadow default_padding next'>
                                                <div className='next_container' onClick={() => setActiveModal('fruits')}>
                                                    <div className='content full'>
                                                        <div className='list visible'>
                                                            <div className='item image_item'>
                                                                <div className='rotate' style={{background: `url(${IMAGES}/banners/hls_image_01_02_02.png)`}}>

                                                                </div>
                                                            </div>
                                                            <div className='item text_item'>
                                                                <div className='rotate'>
                                                                    <p>ТОП полезных продуктов</p>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='next_container reverse' onClick={() => setActiveModal('vegetables')}>
                                                    <div className='content full'>
                                                        <div className='list visible'>
                                                            <div className='item text_item'>
                                                                <div className='rotate'>
                                                                    <p>ТОП полезных овощей</p>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                            <div className='item image_item'>
                                                                <div className='rotate' style={{background: `url(${IMAGES}/banners/hls_image_01_02_02.png)`}}>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </section>
                </>
            }
        </>
    );
};